import React, { useState } from 'react'
import {ModalBase} from '../ModalBase'
import './modal-info-suscripcion.css'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../reducers'
import {generalCloseModalLimite} from '../../../actions/general.actions'
import FeedbackIcon from '@mui/icons-material/Feedback'
import { saveLimiteSuscripcion } from '../../../actions/userLogin.actions'
import { REGEX_HTML } from '../../../constants/Regex'

const ModalLimite = () => {
  const {message, title, color, limite} = useSelector((state: State) => state.general.modalLimite)
  const dispatch = useDispatch()
  const [checkbox, setCheckbox] = useState(false)

  const htmlToJSX = (texto: string) => { return (texto?.match(REGEX_HTML)) ? <div dangerouslySetInnerHTML={{__html: texto}}></div> : texto}

  const close = () => {    
    if(checkbox) dispatch(saveLimiteSuscripcion(limite))
    dispatch(generalCloseModalLimite())
  }

  return (
    <ModalBase Styles={{minWidth: '25%', maxWidth: '550px', backgroundColor: '#fff'}}>
      <div className='modal-info-buttons-fixed-top' style={{backgroundColor:"#fff"}}>
        <div className='w-layout-hflex '>
          <h3 className='modal-infosuscripcion-title'><FeedbackIcon fontSize='large' sx={{color, marginRight:"2%"}} /><div style={{color}}>{title}</div></h3>
        </div>
        <div className='form-separator'></div>
      </div>
      <div className='modal-info-content'>
        <div className='modal-info-message'>{htmlToJSX(message)}</div>
        <div className='modal-infosuscripcion-checkbox'><label className='container-checkbox m'><span style={{fontSize:15}}>No volver a mostrar hasta iniciar sesión nuevamente.</span><input type='checkbox' name='checkContribuyente' checked={checkbox} onChange={() => setCheckbox(!checkbox)} /><span className='checkmark-checkbox'></span></label></div>
      </div>
      <div className='modal-info-buttons-fixed-bottom' style={{backgroundColor:"#fff"}}>
        <div className='w-layout-hflex button-actions'><button autoFocus className='m button w-inline-block' onClick={close}>Aceptar</button></div>
      </div>
    </ModalBase>
  )
}

export default ModalLimite
